<template>
	<v-card
		dark
		color="white"
		class="hor-centered grey--text text--darken-4 max-full-width flag"
		:class="{
			flat: isFullView,
		}"
		:style="{ width: SM ? '100%' : getCardWidth + 'px' }"
	>
		<template>
			<v-card-title primary-title class="pb-2">
				<v-container fluid grid-list-xs class="pa-0 mb-3">
					<v-layout row spacer class="mx-0">
						<v-flex xs9>
							<analytics-el-avatar
								:authorPic="_getAuthorPic(post.authorPic)"
								:authorName="_getSafeStr(post.authorName)"
								:authorId="post.authorId ? post.authorId.N : 'NaN'"
								:postId="isLive ? post.id.N : post.tempId.N"
								:postType="_getPostType(post)"
								:isFullView="isFullView"
							/>
						</v-flex>
						<v-flex xs3>
							<analytics-el-actions
								:post="post"
								:isCommentDisabled="isCommentDisabled"
								:isSharingDisabled="isSharingDisabled"
							/>
						</v-flex>
					</v-layout>
				</v-container>

				<analytics-el-caption :post="post" :isFullView="isFullView"/>
			</v-card-title>

			<div>
				<div v-if="post.repostData" class="px-2 pb-1">
					<repost-ui
						:SM="SM"
						:post="post.repostData"
						:isFullView="isFullView"
						:bypassPreFetch="bypassPreFetch"
						:preFetchImages="preFetchImages"
					></repost-ui>
				</div>

				<analytics-el-graphics
					v-else-if="post.type"
					:SM="SM"
					:post="post"
					:isFullView="isFullView"
					:bypassPreFetch="bypassPreFetch"
					:preFetchImages="preFetchImages"
				/>
			</div>

			<analytics-el-info :post="post"/>
		</template>

		<analytics-el-footer :post="post" :isLive="isLive"/>
	</v-card>
</template>

<script>
import RepostUI from "./repost-ui";
import AnalyticsElAvatar from "./avatar";
import AnalyticsElActions from "./actions";
import AnalyticsElCaption from "./caption";
import AnalyticsElFooter from "./footer";
import AnalyticsElInfo from "./info";
import AnalyticsElImg from "./img";
import AnalyticsElGraphics from "./graphics";

import * as utils from "@/utils.js";

export default {
	name: "AnalyticsEl",
	components: {
		"repost-ui": RepostUI,
		"analytics-el-avatar": AnalyticsElAvatar,
		"analytics-el-actions": AnalyticsElActions,
		"analytics-el-caption": AnalyticsElCaption,
		"analytics-el-info": AnalyticsElInfo,
		"analytics-el-footer": AnalyticsElFooter,
		"analytics-el-img": AnalyticsElImg,
		"analytics-el-graphics": AnalyticsElGraphics
	},
	props: [
		"SM",
		"post",
		"isFullView",
		"isLive",
		"bypassPreFetch",
		"preFetchImages",
		"isCommentDisabled",
		"isSharingDisabled"
	],
	methods: {
		_getSafeStr(obj) {
			return utils._getSafeStr(obj);
		},
		_getAuthorPic(obj) {
			return utils._getAuthorPic(obj);
		},
		_getPostType(post) {
			if (post.repostId) return "repost";
			return this._getSafeStr(post.type);
		}
	},
	computed: {
		getCardWidth() {
			const post = this.post;
			if (
				(post.type &&
					["video", "image", "gif", "link", "text", "audio"].indexOf(
						post.type.S
					) !== -1) ||
				post.repostData
			) {
				return 500;
			}

			const req_width = parseInt(post.width ? post.width.N : 400, 10);
			return Math.max(400, req_width);
		}
		// isAdult() {
		// 	return this.post.adult ? this.post.adult.N === "1" : false;
		// },
	}
};
</script>

<style lang="scss" scoped>
$adultColor: #ff9800;
$reportToolColor: #f44336;

.flag:before {
	content: "";
	position: absolute;
	right: 0;
	left: auto;
	top: 0;
}
.is-adult {
	outline: 5px solid $adultColor !important;
	&:before {
		border-left: 20px solid transparent;
		border-top: 20px solid $adultColor !important;
	}
}
.is-reported {
	outline: 5px solid $reportToolColor !important;
	&:before {
		border-left: 25px solid transparent;
		border-top: 25px solid $reportToolColor !important;
	}
}
</style>
